(()=>{
  // Reinitialise cleanly when the theme editor reloads a section.
  window.__reyalStickyPurchaseCleanup?.();
  const bar=document.getElementById('reyal-sticky-purchase');
  if(!bar)return;
  document.body.appendChild(bar);
  const button=bar.querySelector('button');
  const title=bar.querySelector('.reyal-sticky-purchase__title');
  const error=bar.querySelector('[role="alert"]');
  const main=document.getElementById('MainContent');
  let frame=0;
  const rendered=element=>element&&element.getClientRects().length>0&&getComputedStyle(element).visibility!=='hidden';
  const controls=()=>{
    const root=main?.querySelector('[data-product-root]');
    if(!root)return {root:null,source:null,originals:[]};
    const oneTime=root.querySelector('form[id^="reyal-onetime-"]');
    const oneTimeButton=oneTime?.querySelector('button[type="submit"]');
    const nativeButton=root.querySelector('[data-product-form] .add-to-cart');
    const source=rendered(oneTimeButton)?oneTimeButton:(rendered(nativeButton)?nativeButton:null);
    const originals=Array.from(root.querySelectorAll('.reyal-choice-submit,[data-product-form] .add-to-cart')).filter(rendered);
    return {root,source,originals};
  };
  const update=()=>{
    frame=0;
    const {root,source,originals}=controls();
    const drawer=document.getElementById('right-drawer-slot');
    const dialogOpen=rendered(drawer)||Array.from(document.querySelectorAll('[aria-modal="true"],dialog[open]')).some(rendered);
    const visible=!!source&&originals.length>0&&originals.every(el=>el.getBoundingClientRect().bottom<=0)&&!dialogOpen;
    const text=source?.innerText.trim().replace(/\s+/g,' ').replace(/\s>\s/g,' → ')||'';
    if(button.textContent!==text)button.textContent=text;
    button.disabled=!source||source.disabled;
    const productName=root?.querySelector('[data-product-title]')?.textContent.trim();
    if(productName&&title.textContent!==productName)title.textContent=productName;
    const sourceError=source?.form?.querySelector('.reyal-choice-error,[x-text="errorMessage"]');
    const message=rendered(sourceError)?sourceError.textContent.trim():'';
    if(error.textContent!==message)error.textContent=message;
    error.hidden=!message;
    if(bar.dataset.visible!==String(visible)){
      bar.dataset.visible=String(visible);
      bar.setAttribute('aria-hidden',String(!visible));
      bar.inert=!visible;
    }
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
  const click=()=>{
    const {source}=controls();
    if(source&&!source.disabled){
      // Use the original one-time form, including its variant, quantity and cart handling.
      source.click();
      schedule();
    }
  };
  button.addEventListener('click',click);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule);
  document.addEventListener('change',schedule);
  document.addEventListener('input',schedule);
  const events=['right-drawer-is-open','right-drawer-is-closed','shopify:section:load'];
  events.forEach(name=>window.addEventListener(name,schedule));
  const observer=new MutationObserver(schedule);
  if(main)observer.observe(main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','class','style','hidden']});
  const drawer=document.getElementById('right-drawer-slot');
  if(drawer)observer.observe(drawer,{attributes:true,attributeFilter:['style','class','aria-modal']});
  const resize=new ResizeObserver(schedule);
  if(main)resize.observe(main);
  window.__reyalStickyPurchaseCleanup=()=>{
    cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();
    window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);
    document.removeEventListener('change',schedule);document.removeEventListener('input',schedule);
    events.forEach(name=>window.removeEventListener(name,schedule));
    button.removeEventListener('click',click);bar.remove();
  };
  schedule();
})();
